import * as React from 'react';

import esplanade from 'gallery/esplanade.jpg';
import washburn from 'gallery/washburn.jpg';
import ImageGalleryGrid from 'components/ImageGalleryGrid';

const itemData = [
  {
    // src: 'https://live.staticflickr.com/4397/36718597011_23340503ae_b.jpg',
    // src: 'https://images.fineartamerica.com/images-medium-large-5/boston-skyline-at-sunset-c-swapan-jha.jpg',
    //src: 'https://i.etsystatic.com/7920518/r/il/a5aba5/1172411655/il_1080xN.1172411655_9wqj.jpg',
    src: 'https://res.cloudinary.com/dtljonz0f/image/upload/c_auto,ar_3:1,w_3840,g_auto/f_auto/q_auto/v1/gc-v1/boston/Boston-sunset-cruise%20(1)?_a=BAVARSAP0',
    title: 'City of Boston',
    rows: 1,
    cols: 4,
  },
  {
    src: 'https://i.pinimg.com/736x/9a/50/7c/9a507c26418b9866e85b2e214747c181.jpg',
    title: 'Altar at the Washburn Pavilion',
    rows: 1,
    cols: 2,
  },
  {
    src: 'https://res.cloudinary.com/hello-tickets/image/upload/c_limit,f_auto,q_auto,w_768/v1661832312/post_images/Boston-30/Boston-city-pass/51782613447_3aee88940e_o_Cropped.jpg',
    title: 'Museum of Science',
    rows: 1,
    cols: 1,
  },
  {
    src: esplanade,
    title: 'The Esplanade',
    rows: 1,
    cols: 1,
    lowRes: true,
  },
  {
    src: washburn,
    title: 'Washburn Pavilion',
    rows: 1,
    cols: 4,
  },
];

export default function VenueGallery() {
  return (
    <ImageGalleryGrid images={itemData} />
  );
}
